exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.see-through[data-v-1b7ab40c] {\n    opacity: 0.2;\n}\n", ""]);

// exports
